import React, { useEffect, useState } from 'react';
import { LuMessageSquareCode } from 'react-icons/lu';
import { Modal } from '../ui/Modal';
import SegmentedControl from '../ui/SegmentedControl';
import EmptyState from '../ui/EmptyState';
import Badge from '../ui/Badge';

/** Read-only view of the analysis prompts configured for the client. */
const PromptsModal = ({ isOpen, onClose, analysisConfig = [] }) => {
  const [active, setActive] = useState(analysisConfig[0]?.slug ?? null);

  useEffect(() => {
    if (isOpen) setActive(analysisConfig[0]?.slug ?? null);
  }, [isOpen, analysisConfig]);

  const current = analysisConfig.find((c) => c.slug === active) || analysisConfig[0];

  return (
    <Modal isOpen={isOpen} onClose={onClose} icon={LuMessageSquareCode} title="Prompts d'analyse" subtitle="Consignes envoyées à l'IA pour chaque analyse du rapport." size="lg">
      {analysisConfig.length === 0 ? (
        <EmptyState icon={LuMessageSquareCode} tone="gray" title="Aucun prompt configuré" description="Ajoutez des analyses dans la configuration du client." />
      ) : (
        <div className="space-y-4">
          {analysisConfig.length > 1 && (
            <SegmentedControl
              size="sm"
              ariaLabel="Analyses"
              value={current?.slug}
              onChange={setActive}
              options={analysisConfig.map((c) => ({ value: c.slug, label: c.name || c.slug }))}
            />
          )}
          <div className="flex items-center justify-between gap-3">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{current?.name || current?.slug}</h3>
            <Badge tone="slate" size="sm" className="font-mono">{current?.slug}</Badge>
          </div>
          {current?.prompt ? (
            <pre className="max-h-[55vh] overflow-auto whitespace-pre-wrap rounded-xl border border-gray-200 bg-gray-50 p-4 font-mono text-[13px] leading-relaxed text-gray-800 dark:border-gray-800 dark:bg-night-900 dark:text-gray-200">
              {current.prompt}
            </pre>
          ) : (
            <p className="text-sm italic text-gray-500 dark:text-gray-400">Aucun prompt défini pour cette analyse.</p>
          )}
        </div>
      )}
    </Modal>
  );
};

export default PromptsModal;
